import QuotesGrid from '../../components/grids/QuotesGrid'
import AddQuoteForm from '../../components/FormComps/Quotes/AddQuoteForm'
import EditQuoteForm from '../../components/FormComps/Quotes/EditQuoteForm'

import { useState, useEffect } from 'react'
import { useToast } from '../../contexts/ToastContext'
import { useSessionState } from '../../helpers/useSessionState'

import { useNavigate, useSearchParams } from 'react-router-dom'

import {
  Drawer,
  DrawerContent,
  DrawerNavigation,
} from '@progress/kendo-react-layout'
import { Dialog } from '@progress/kendo-react-dialogs'
import { FaTimes } from 'react-icons/fa'
import {
  submitQuote,
  updateQuote,
  getQuotes,
  quoteLost,
  quoteWon,
  getQuoteTemplates,
  QuoteTemplate
} from '../../data/quoteData'
import { getTargetJob, submitJob, updateJobSageTest } from '../../data/jobData'
import { DateFormatterReverse } from '../../data/helper'
import { quotesGrid, getSiteTypes, dropDown } from '../../data/interfaces'
import { deleteDocument } from '../../data/fileData'
import { submitSite, getSites } from '../../data/siteData'
import {
  postWorkType,
  submitWorktype,
  getWorktypeDropdown,
} from '../../data/worktypeData'

import AddSiteForm from '../../components/FormComps/Sites/AddSiteForm'
import AddWorkTypeForm from '../../components/FormComps/Worktypes/AddWorkTypeForm'

import '../Styles.css'
import { FormDropDownList, FormInput, FormNumericTextBox, FormTextArea } from '../../components/FormComps/FormComponents'
import AccountForm from '../../components/FormComps/Accounts/AccountForm'

interface QuotesProps {
  lockEdit: boolean
}

const Quotes = (props: QuotesProps) => {
  const [visibleSiteModal, setVisibleSiteModal] = useState<boolean>(false)
  const [visibleWorktypeModal, setVisibleWorktypeModal] =
    useState<boolean>(false)

  const [siteData, setSiteData] = useState<getSiteTypes[]>([])
  const [worktypeData, setWorkTypeData] = useState<dropDown[]>([])
  const [quoteData, setQuoteData] = useState<quotesGrid[]>([])
  const [jobData, setJobData] = useState<any>({})

  const dateFormatterReverse = new DateFormatterReverse()
  const [expanded, setExpanded] = useState(false)
  const [editFormVisible, setEditFormVisible] = useState(false)
  const [addFormVisible, setAddFormVisible] = useState(false)
  const [quoteId, setQuoteId] = useState(0)
  /** Formatted reference of the quote being edited, shown in the panel header */
  const [editQuoteRef, setEditQuoteRef] = useState('')

  // Responsive quote-drawer width: roomier on large screens (room for the new
  // vertical nav rail), and caps at the viewport on smaller displays.
  const [quoteDrawerWidth, setQuoteDrawerWidth] = useState(() =>
    Math.min(1200, Math.round(window.innerWidth * 0.94))
  )
  useEffect(() => {
    const onResize = () =>
      setQuoteDrawerWidth(Math.min(1200, Math.round(window.innerWidth * 0.94)))
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  // Same session keys as QuotesGrid so the page and the grid restore in step
  const [showRejected, setShowRejected] = useSessionState('quotes.showRejected', false)
  const [showAccepted, setShowAccepted ] = useSessionState('quotes.showAccepted', false)
  const [monthCreatedBy, setMonthCreatedBy] = useSessionState<number | null>('quotes.currentMonth', null)
  const [refreshKey, setRefreshKey] = useState(0)

  const [quoteScreenActive, setQuoteScreenActive] = useState(false);
  const [quoteDetails, setQuoteDetails] = useState({
    shortDescription: "",
    worksDescription: "",
    qualificationsDescription: "",
    totalCost: 0,
  });
    /** All templates */
    const [quoteTemplates, setQuoteTemplates] = useState<QuoteTemplate[]>([]);

  const { showToast } = useToast()
  const navigate = useNavigate()
  const [clientFromIncoming, setClientFromIncoming] = useState<string>("")


  const [searchParams] = useSearchParams();
  useEffect(() => {
    const id = searchParams.getAll("id")[0];
    const client = searchParams.getAll("client")[0];
    if(id) {
      setExpanded(true);
      setEditFormVisible(true);
      setQuoteId(Number(id))
    }
    if(client){
      setClientFromIncoming(client);
    }
  }, [])  

  const handleRejected = (value: boolean) => {
    setShowRejected(value)
  }

  const handleAccepted = (value: boolean) => {
    setShowAccepted(value)
  }

  const handleMonthCreated = (value: any) => {
    setMonthCreatedBy(value);
  }

  const getQuoteData = async (filterIds: any) => {
    const fetchData = async () => {
      const quoteData = await getQuotes(showRejected, monthCreatedBy, filterIds, showAccepted)
      setQuoteData(quoteData)
    }

    fetchData()
  }

  const handleQuoteCreatedBy = (filterIds: number[]) => {
    getQuoteData(filterIds);
  }

  const handleAddForm = () => {
    setAddFormVisible((prevState) => (!prevState ? true : true))
    setEditFormVisible(false)
    handleExpanded()
  }

  const handleEditForm = (id: number) => {
    setQuoteId(id)
    setEditQuoteRef('') // cleared until the form reports the loaded reference
    setEditFormVisible((prevState) => (!prevState ? true : true))
    setAddFormVisible(false)
    handleExpanded()
  }

  const handleQuoteForm = (id: number) => {
    handleExpanded()
    // setQuoteId(id)
    // setQuoteScreenActive(true);
    setEditFormVisible(true);
  }

  const toggleModal = (type: string) => {
    switch (type.toLowerCase()) {
      case 'site':
        setVisibleSiteModal(!visibleSiteModal)
        break
      case 'worktype':
        setVisibleWorktypeModal(!visibleWorktypeModal)
        break
      default:
        console.log('Invalid modal type.')
        break
    }
  }

  const updateQuoteHandler = (dataItem: any, id: number) => {
    const quoteObj = {
      quoteUrl: dataItem.quoteUrl,
      quoteId: id,
      clientId: dataItem.clientName.value,
      siteId: dataItem.siteAddr.value,
      contactId: dataItem.contact.contactId,

      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: dataItem.enquirysourceId.value,
      description: dataItem.description,
      worktypeId: dataItem.worktypeId.value,
      cost: dataItem.cost,
      followupDate: dateFormatterReverse.format(dataItem.followupDate),
      wonDate: dateFormatterReverse.format(dataItem.wonDate),
      lostDate: dateFormatterReverse.format(dataItem.lostDate),
      enquiryId:
        dataItem.enquiryDesc && dataItem.enquiryDesc.value
          ? dataItem.enquiryDesc.value
          : null,
      employeeAssignedToId: dataItem.employeeAssignedToId.value,
      quoteTemplateId: dataItem.quoteTemplateId,
      shortDescription:	dataItem.shortDescription,
      worksDescription:	dataItem.worksDescription,
      qualsDescription:	dataItem.qualsDescription,
      value: dataItem.value,
      isSent: dataItem.isSent,
      projectFolderUrl: dataItem.projectFolderUrl,
      likelihoodId: dataItem.likelihoodId ? dataItem.likelihoodId.value : null,
      requireFollowups: dataItem.requireFollowups ?? true,
      workingsAdjustmentPercent: dataItem.workingsAdjustmentPercent ?? null,
    }

    updateQuote(quoteObj, id).then(() => {
      const fetchData = async () => {
        const quoteData = await getQuotes(showRejected, monthCreatedBy, [], showAccepted)
        setQuoteData(quoteData)
      }
      fetchData()
      // Increment refresh key to trigger grid reload
      setRefreshKey(prev => prev + 1)
    })
    handleExpanded()
    showToast('Quote succesfully updated', 'success')
  }

  const newQuoteHandler = (dataItem: any) => {
    const quoteObj = {
      clientId: dataItem.clientName.value,
      siteId: dataItem.siteAddr.value,
      contactId: dataItem.contact.value,
      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: dataItem.enquirysourceId.value ? dataItem.enquirysourceId.value : 0,
      description: dataItem.description,
      worktypeId: dataItem.worktypeId.value,
      cost: dataItem.cost,
      followupDate: dataItem.followupDate
        ? dataItem.followupDate.toISOString()
        : null,
      enquiryId:
        dataItem.enquiryDesc && dataItem.enquiryDesc.value
          ? dataItem.enquiryDesc.value
          : null,
      employeeAssignedToId: dataItem.employeeAssignedToId.value,
      likelihoodId: dataItem.likelihoodId ? dataItem.likelihoodId.value : null,
      requireFollowups: dataItem.requireFollowups ?? true,
    }
    submitQuote(quoteObj).then(() => {
      handleRefreshData()
    })
    handleExpanded()
    showToast('Quote succesfully added', 'success')
  }

  const newSiteHandler = (dataItem: any) => {
    const siteObj = {
      siteAddr: dataItem.siteAddr,
      postcode: dataItem.postcode,
    }
    submitSite(siteObj).then(() => {
      const fetchData = async () => {
        const siteData = await getSites(false)
        setSiteData(siteData)
      }
      fetchData()
    })
    toggleModal('site')
    showToast('Site succesfully added', 'success')
  }

  const newWorkTypeHandler = (dataItem: postWorkType) => {
    submitWorktype(dataItem).then(() => {
      const fetchData = async () => {
        const workTypes = await getWorktypeDropdown()
        setWorkTypeData(workTypes)
      }
      fetchData()
    })
    toggleModal('worktype')
    showToast('Worktype succesfully added', 'success')
  }

  const convertQuoteHandler = (dataItem: any) => {
    const jobObj = {
      jobId: null,
      clientId: Number(dataItem.clientName.value),
      siteId: Number(dataItem.siteAddr.value),
      contactId: Number(dataItem.contact.contactId),
      //TODO: 11th Feb remove hardcoded priorityId
      priorityId: 1,
      enquirysourceId: Number(dataItem.enquirysourceId.value),
      departmentId: 1,
      description: dataItem.description,
      purchaseOrder: dataItem.purchaseOrder,
      worktypeId: Number(dataItem.worktypeId.value),
      cost: dataItem.cost,
      proformaCost: dataItem.proformaCost,
      firstHourInvoiced: dataItem.firstHourInvoiced,
      startDate: dateFormatterReverse.format(dataItem.startDate),
      endDate: dateFormatterReverse.format(dataItem.endDate),
      employeeProjectManagerId: Number(dataItem.employeeProjectManagerId),
      quoteId: dataItem.quoteId,
      jobEmployeeIds: dataItem.jobEmployeeIds,
      // The quote form holds the enquiry as a plain id (0 when there is none),
      // not a dropdown { value } - reading .value here sent NaN, which went
      // over the wire as null and left the job unlinked from its enquiry.
      enquiryId: Number(dataItem.enquiryId) > 0 ? Number(dataItem.enquiryId) : null,
      notifiableWorks: Array.isArray(dataItem.notifiableWorks) ? dataItem.notifiableWorks.join(',') : (dataItem.notifiableWorks || ''),
    }

    

    submitJob(jobObj).then((res) => {
      console.log("res", res);

      const newJobId = res && res.jobId ? res.jobId : 0;

      console.log("newJobId", newJobId);

      quoteWon(dataItem.quoteId, newJobId);
      navigate('/jobs');
    })
    handleExpanded()
    showToast('Job succesfully added', 'success')
  }

  const fetchJobData = async (id: number) => {
    try {
      const data = await getTargetJob(id);
      return data;
    } catch (error) {
      console.error(`Error fetching job data: ${error}`);
      showToast('Error fetching job data', 'error');
    }
  };

  // Append the newly selected notifiable works to whatever the job already has,
  // de-duplicated, so converting to an existing job adds works without dropping
  // or duplicating any already applied.
  const mergeNotifiableWorks = (existing: any, selected: any): string => {
    const toList = (value: any): string[] =>
      Array.isArray(value)
        ? value
        : typeof value === 'string'
          ? value.split(',')
          : [];
    const merged = [...toList(existing), ...toList(selected)]
      .map((work) => String(work).trim())
      .filter(Boolean);
    return Array.from(new Set(merged)).join(',');
  };

  const updateJobData = (data: any, dataItem: any, prevState: any) => ({
    ...prevState,
    siteId: dataItem.siteAddr.value,
    clientId: dataItem.clientName.value,
    contactId: data.contact.contactId,
    priorityId: 1,
    worktypeId: dataItem.worktypeId.value,
    departmentId: data.department.departmentId,
    employeeProjectmanager: data.employeeProjectmanager.employeeId,
    description: `${data.description}`,
    cost: data.cost + dataItem.cost,
    notifiableWorks: mergeNotifiableWorks(data.notifiableWorks, dataItem.notifiableWorks),
  });

  //This is hit once the convert to existing job button is clicked
  const convertQuoteHandlerExisting = async (dataItem: any, jobId: number, quoteId: number) => {
    try {
      const data = await fetchJobData(jobId);
      console.log("DATA", data)
      if (!data) return;

      const updatedJobData = updateJobData(data, dataItem, jobData);
      setJobData(updatedJobData);
      console.log("updatedJobData", updatedJobData)
      const sageres = await updateJobSageTest(updatedJobData, jobId);
      console.log("sagereg", sageres)
      const quotewonres = await quoteWon(quoteId, sageres.jobId);
      console.log(quotewonres)
      navigate('/jobs');

      handleExpanded();
      showToast('Job successfully updated', 'success');
    } catch (error) {
      console.error(`Error in convertQuoteHandlerExisting: ${error}`);
      console.log(error)
      showToast('Error updating job', 'error');
    }
  };


  const quoteLostHandler = (id: number) => {
    quoteLost(id).then(() => {
      const fetchData = async () => {
        const quoteData = await getQuotes(showRejected, monthCreatedBy)
        setQuoteData(quoteData)
      }
      fetchData()
      // Increment refresh key to trigger grid reload
      setRefreshKey(prev => prev + 1)
    })
    handleExpanded()
    showToast('Quote marked as lost', 'success')
  }

  const removeDocuemntHandler = (id: number) => {
    deleteDocument(id).then(() => {
      const fetchData = async () => {
        const quoteData = await getQuotes(showRejected, monthCreatedBy)
        setQuoteData(quoteData)
      }
      fetchData()
      // Increment refresh key to trigger grid reload
      setRefreshKey(prev => prev + 1)
    })
    showToast('Successfully removed document', 'success')
  }

  useEffect(() => {
    const fetchData = async () => {
      const quotesData = await getQuotes(showRejected, monthCreatedBy, [], showAccepted)
      setQuoteData(quotesData)
    }

    fetchData()
  }, [showRejected, monthCreatedBy, showAccepted])

  const handleExpanded = () => {
    setExpanded((prevState) => !prevState)

    if (editFormVisible) {
      setEditFormVisible(false)
      setQuoteId(0) // Reset quoteId to force form remount when reopened
      setEditQuoteRef('')
    }
    if (addFormVisible) {
      setAddFormVisible(false)
    }

    if(quoteScreenActive){
      setQuoteScreenActive(false);
    }
  }

  const handleClosePanel = () => {
    setExpanded(false);
    setEditFormVisible(false);
    setAddFormVisible(false);
    setQuoteScreenActive(false);
  };

  const handleRefreshData = async () => {
    const quotesData = await getQuotes(showRejected, monthCreatedBy, [], showAccepted);
    setQuoteData(quotesData);
    setRefreshKey(prev => prev + 1);
  };

  const handleSelect = () => {
    setExpanded(false)
  }


  /**
 * Handles the change event for input fields.
 * Updates the selected quote state with the new value.
 * 
 * @param {Object} event - The event object containing the target element.
 */
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setQuoteDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

    /**
     * Retrieves the text message templates and sets them in the component state.
     * @returns {Promise<void>} A promise that resolves when the templates are retrieved and set.
     */
    const fetchQuotes = async (): Promise<void> => {
      const quotes = await getQuoteTemplates();
      setQuoteTemplates(quotes);
  };

  useEffect(() => {
    if(quoteScreenActive){
      fetchQuotes();
    }
  }, [quoteScreenActive])

  
  /**
   * Account 
   */
  const [addAccountVisible, setAddAccountVisible] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const [accountMode, setAccountMode] = useState<"add"|"edit">("add");
  const [accountInitialTab, setAccountInitialTab] = useState<number>(0);

  /**
   * END account 
   */

  return (
    <div>
      <Drawer
        expanded={expanded}
        position={'end'}
        width={quoteDrawerWidth}
        mode='overlay'
        animation={{
          duration: 400,
        }}
        onOverlayClick={handleExpanded}
        onSelect={handleSelect}
      >
        <DrawerContent>
          <DrawerNavigation>
            {addFormVisible && (
              <>
                <div className='jobdrawer__header'>
                  <h1 className='jobdrawer__title'>Add Quote</h1>
                  <button
                    type='button'
                    className='jobdrawer__close'
                    onClick={handleExpanded}
                    aria-label='Close'
                  >
                    <FaTimes />
                  </button>
                </div>
                <div className='form__wrapper'>
                  <AddQuoteForm
                    onQuoteSubmit={newQuoteHandler}
                    onAddSiteToggle={() => toggleModal('site')}
                    onAddWorkTypeToggle={() => toggleModal('worktype')}
                    updatedWorkTypes={worktypeData}
                    quoteTemplates={quoteTemplates}
                    setAddAccountVisible={setAddAccountVisible}
                    setAccountMode={setAccountMode}
                    setSelectedAccountId={setSelectedAccountId}
                    setAccountInitialTab={setAccountInitialTab}                                      
                  />
                </div>
              </>
            )}

            {editFormVisible && (
              <>
                <div className='jobdrawer__header'>
                  <h1 className='jobdrawer__title'>
                    {quoteScreenActive ? 'Quote Template' : 'Edit Quote'}
                    {!quoteScreenActive && editQuoteRef && (
                      <span className='jobdrawer__ref'>{editQuoteRef}</span>
                    )}
                  </h1>
                  <button
                    type='button'
                    className='jobdrawer__close'
                    onClick={handleExpanded}
                    aria-label='Close'
                  >
                    <FaTimes />
                  </button>
                </div>
                <EditQuoteForm
                  lockEdit={props.lockEdit}
                  onEditSubmit={updateQuoteHandler}
                  onQuoteId={quoteId}
                  onConvertSubmit={convertQuoteHandler}
                  onConvertToExistingSubmit={convertQuoteHandlerExisting}
                  onQuoteLost={quoteLostHandler}
                  onDocumentDelete={removeDocuemntHandler}
                  onAddSiteToggle={() => toggleModal('site')}
                  onAddWorkTypeToggle={() => toggleModal('worktype')}
                  updatedWorkTypes={worktypeData}
                  isQuoteForm={quoteScreenActive}
                  handleExpanded={handleExpanded}
                  quoteTemplates={quoteTemplates}
                  setAddAccountVisible={setAddAccountVisible}
                  setAccountMode={setAccountMode}
                  setSelectedAccountId={setSelectedAccountId}
                  setAccountInitialTab={setAccountInitialTab}
                  onClose={handleClosePanel}
                  onRefresh={handleRefreshData}
                  onQuoteLoaded={setEditQuoteRef}
                />
              </>
            )}

          </DrawerNavigation>

          <QuotesGrid
            clientFromIncoming={clientFromIncoming}
            lockEdit={props.lockEdit}
            onAddToggle={handleAddForm}
            onEditToggle={handleEditForm}
            onData={quoteData}
            onExportData={quoteData}
            onShowRejected={handleRejected}
            onShowAccepted={handleAccepted}
            onMonthCreatedBy={handleMonthCreated}
            onQuoteCreatedBy={handleQuoteCreatedBy}
            handleQuoteForm={handleQuoteForm}
            refreshKey={refreshKey}
          />

          {visibleSiteModal && (
            <Dialog
              width={500}
              height={700}
              title={'Please confirm'}
              onClose={() => toggleModal('site')}
            >
              <AddSiteForm onSiteSubmit={newSiteHandler} />
            </Dialog>
          )}
          {visibleWorktypeModal && (
            <Dialog
              width={500}
              height={700}
              title={'Please confirm'}
              onClose={() => toggleModal('worktype')}
            >
              <AddWorkTypeForm onWorkTypeSubmit={newWorkTypeHandler} />
            </Dialog>
          )}
          {addAccountVisible && (
            <Dialog
              width={"70vw"}
              height={"90vh"}
              title={"Add new account"}
              onClose={() => setAddAccountVisible(false)}
            >
              <AccountForm
                onClose={() => setAddAccountVisible(false)}
                mode={accountMode} 
                id={selectedAccountId || null} 
                setAccountId={(id) => setSelectedAccountId(id)}
                initialTab={accountInitialTab}/>

            </Dialog>
          )}          
        </DrawerContent>
      </Drawer>
    </div>
  )
}

export default Quotes
